import React from 'react'
import { PrintOrderDetailListPage } from '../../../components/templates/reusable-orders/print/print-order-detail-list-page'

export const ReusableDeliveryReceipt = () => {
  return <PrintOrderDetailListPage title="VIXELL Delivery Notes" />
}
